import { useEffect, useState } from 'react';
import { PageLayout } from '../../PageLayout';
import { getAccounts, getAccountScope, getUser } from '../../../store/User';
import { DashboardWidgets } from '../../Compounds/DashboardWidgets';
import { SummativeWidget } from '../../Compounds/SummativeWidget';
import { getInventorySubject, useInventory } from '../../../store/Inventory';
import { getCaseSubject, useSupportCases } from '../../../store/SupportCase';
import { InventoryAsset, SupportCasesItem } from '../../../types';
import { combineLatest } from 'rxjs';
import { CustomizeDashboardDrawer } from '../../Compounds/CustomizeDashboardDrawer';
import { AccountModal } from '../../Compounds/Modals/AccountModal';
import { ServiceRequestLink } from '../../Compounds/ServiceRequest/ServiceRequestLink';

export const AccountHomePage = () => {
  const accounts = getAccounts();

  // Only show modal if user has more than one account.
  if (!getAccountScope()?.length && accounts?.length) {
    if (accounts.length > 1) return <AccountModal />;
  }
  const [inventoryAssets, setInventoryAssets] = useState<InventoryAsset[]>([]);
  const [cases, setCases] = useState<SupportCasesItem[]>([]);
  const [isShowCustomizeDrawer, setIsShowCustomizeDrawer] = useState(true);
  const { fetchCases } = useSupportCases();
  const { fetchInventory } = useInventory();
  const user = getUser();

  const initAppData = (forceRefresh = false) => {
    fetchCases(forceRefresh);
    fetchInventory(forceRefresh);
  };

  useEffect(() => initAppData(), []);

  useEffect(() => {
    // TODO: temporary changes
    setIsShowCustomizeDrawer(!['Sephora USA', 'STEVEN MADDEN LTD'].includes(user.account_name || ''));
  }, [user?.account_name]);

  useEffect(() => {
    const dataSubscription = combineLatest({
      inventory: getInventorySubject(),
      cases: getCaseSubject()
    }).subscribe(({ inventory, cases }) => {
      (setInventoryAssets(inventory), setCases(cases));
    });

    return () => {
      if (dataSubscription) dataSubscription.unsubscribe();
    };
  }, []);

  const drawerAction = () => (
    <ServiceRequestLink
      ctaClassName="text-grey-12 text-sm"
      label="New Order Request"
    />
  );

  const pageActions = () => (
    <>
      {isShowCustomizeDrawer ? (
        <CustomizeDashboardDrawer
          title="Home"
          action={drawerAction()}
        />
      ) : (
        <div>{drawerAction()}</div>
      )}
    </>
  );

  return (
    <PageLayout
      dataCy="home-container"
      pageTitle="Home"
      pageActions={pageActions()}>
      <>
        <SummativeWidget inventoryAssets={inventoryAssets} />
        <div className="flex flex-wrap text-center pb-20">
          <DashboardWidgets
            inventoryAssets={inventoryAssets}
            pageTitle="Home"
            cases={cases}
            projects={[]}
          />
        </div>
      </>
    </PageLayout>
  );
};
